//#region DevExtreme Imports

import 'devextreme/ui/check_box'
import 'devextreme/ui/scroll_view'

//#endregion

import { IMRBaseComponent } from '../base'
import { IMRParametersController } from "./parameters.controller"
import { USER_SESSION_SERVICE_NAME } from '../../../services/user-session'

//#region Assets Imports

import './parameters.scss'
import * as TEMPLATE from './parameters.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'imrParameters'

export class IMRParametersComponent extends IMRBaseComponent {

    //#region Ctor

    public constructor() {
        super({
            controller: IMRParametersController,
            services: [USER_SESSION_SERVICE_NAME],
            template: TEMPLATE
        })
    }

    //#endregion
}
